import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type User from "./User";

@Model()
class SpellingCorrectionRule extends ApplicationRecord {
  static jsonapiType = "spelling_correction_rules";

  @Attr() archivedAt: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr() match: string;

  @Attr() matchOnWordBoundaries: boolean;

  @Attr() notes: string;

  @Attr() replacement: string;

  @Attr({ persist: false }) updatedAt: string;

  @BelongsTo() user: User;
}

export default SpellingCorrectionRule;
